export default {
  title: 'Payer avec {{method}}',
  hint: 'Ensuite, confirmez le paiement avec votre banque ou dans votre application.',
  continue: 'Continuer',
  cancel: 'Annuler le paiement',
  unavailable: "Ce mode de paiement n'est pas disponible pour le moment. Choisissez-en un autre.",
};
